import axios from './axiosInstance'

const setDefaults = () => {
  axios.defaults.headers.common['Content-Type'] =
    'application/x-www-form-urlencode'
  axios.defaults.headers.common.Accept = 'application/json'
}

const GetSuggestions = ({ h3Index, q }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios
      .get('/search/suggestions', {
        params: { h3Index, q }
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const GetLifelineSuggestions = ({ token, term, type, venue }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/search/lifeline/suggestions', { term, type, venue })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const SearchVenuesByText = ({ q }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios
      .get('/search/venuesByText', { params: { q } })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const GetVenuesWithInRange = ({ h3Index }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios
      .get('/search/venues/', { params: { h3Index } })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const SearchVenuesWithProducts = ({ h3Index, q }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios
      .get('/search/venues/', { params: { h3Index, q } })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

export {
  GetSuggestions,
  SearchVenuesByText,
  GetVenuesWithInRange,
  SearchVenuesWithProducts,
  GetLifelineSuggestions
}
